import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: '5px 0',
    display: 'flex',
    '& > div:first-child': {
      width: '32%',
    },
    '& > div:nth-child(2)': {
      width: '28%',
    },
    '& > div:last-child': {
      width: '40%',
    },
    '& p': {
      margin: '0',
      fontSize: '0.813em',
    },
  },
}));

const HorseDetails = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div>
        <p>Breed: AQHA</p>
        <p>Color: GRAY</p>
        <p>Sex: MARE</p>
      </div>
      <div>
        <p>Born: 2008</p>
        <p>Height: 15</p>
        <p>Tattoo:</p>
      </div>
      <div>
        <p>Name: WW MONA LISA</p>
        <p>Reg N: 5131549</p>
        <p>Brand:</p>
      </div>
    </div>
  );
};

export default HorseDetails;
